export const LOS_ED_EVENT = Object.freeze({
  OPEN_PROFILE: "acc-wc-los-ed-open-profile",
  OPEN_PERFORMANCE: "acc-wc-los-ed-open-performance",
  ISOLATE_DOWNLINE: "acc-wc-los-ed-isolate-downline",
});

export const TERMS_CONDITIONS_EVENT = Object.freeze({
  AGREE: "tc-agree",
  DISAGREE: "tc-disagree",
});

export const EDLOS_ABO_META_EVENT = Object.freeze({
  REQUEST: "acc-wc-los-ed-request-abo-meta",
  RESPONSE: "acc-wc-los-ed-abo-meta",
});
